import {
  faCamera,
  faImages,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useFormik} from "formik";
import React, {useContext, useEffect, useRef, useState} from "react";
import {Modal} from "react-bootstrap";
import {StoreContext} from "../../store/StoreContext";
import {
  Camera,
  CameraDirection,
  CameraResultType,
  CameraSource,
} from "@capacitor/camera";
import "./dialogFormFinding.scss";
import _ from "lodash";
import {base64ToBlob, fileToBase64, imageCompressor} from "../../helpers";
import {toast} from "../../alerts/sweetalert";
import * as Yup from "yup";

const imagesLimit = 3;

const DialogFormFinding = props => {
  const {
    open,
    control,
    edit,
    finding,
    isPreview,
    questions = [],
    findingCategories = [],
    isIncidentReport = false,
    showCategory = true,
    totalImageCount = 0,
    globalImgLimit = 15,
  } = props;

  const {online, platform} = useContext(StoreContext);
  const uploadFile = useRef(null);

  const [images, setImages] = useState([]);

const handleSubmit = values => {
  const newData = { ...values, images };
  if (!isIncidentReport && showCategory) {
    const categoryObj = findingCategories.find(c => String(c.id) === String(values.CategoriaId));
    newData.Hallazgo = categoryObj?.title || finding?.Hallazgo || "Hallazgo";
  }
  if (finding?.HallazgoId) {
    edit(newData, finding.HallazgoId);
  }
  control(false);
};



const validationSchema = Yup.object().shape({
  Observacion: Yup.string().trim().required("La observación es obligatoria"),
  ...(!isIncidentReport && showCategory ? {
    Evaluacion: Yup.string().required("La evaluación es obligatoria"),
    CategoriaId: Yup.string().required("La categoría es obligatoria"),
  } : {}),
});

const formik = useFormik({
  enableReinitialize: true,
  initialValues: {
    Observacion: finding?.Observacion || "",
    Evaluacion: finding?.Evaluacion || "",
    CategoriaId: finding?.CategoriaId || "",
  },
  validationSchema,
  onSubmit: values => {
    handleSubmit(values);
    formik.resetForm();
  },
});


  useEffect(() => {
    if (!finding) return;

    formik.setFieldValue("Observacion", finding.Observacion);
    formik.setFieldValue("Evaluacion", finding.Evaluacion || "");
    formik.setFieldValue("CategoriaId", finding.CategoriaId || "");
    setImages(finding?.images || []);
  }, [finding]);

  useEffect(() => {
    if (!open) {
      formik.resetForm();
      setImages([]);
    }
  }, [open]);

  const handleDeleteImage = index => {
    const _images = _.clone(images);
    _images.splice(index, 1);
    setImages(_images);
  };

  const getRemainingGlobal = () => {
    const originalCount = finding?.images?.length || 0;
    const otherImages = totalImageCount - originalCount;
    return globalImgLimit - otherImages - images.length;
  };

  const takePhoto = async source => {
    if (platform === "web" || images.length >= imagesLimit) return;
    if (getRemainingGlobal() <= 0) {
      toast({ icon: "warning", title: `Límite de ${globalImgLimit} imágenes por formulario alcanzado. Reduzca imágenes en otros hallazgos.` });
      return;
    }

    Camera.getPhoto({
      quality: 60,
      allowEditing: false,
      saveToGallery: false,
      resultType: CameraResultType.Base64,
      source,
      direction: CameraDirection.Rear,
    })

      .then(image => {
        const base64 = `data:image/${image.format};base64,${image.base64String}`;
        return base64ToBlob(base64);
      })
      .then(blob => imageCompressor(blob))
      .then(compressed => fileToBase64(compressed))
      .then(newBase64 => setImages(prev => [...prev, newBase64]));
  };

  const webUpload = files => {
    if (platform !== "web" || images.length >= imagesLimit) return;
    if (getRemainingGlobal() <= 0) {
      toast({ icon: "warning", title: `Límite de ${globalImgLimit} imágenes por formulario alcanzado. Reduzca imágenes en otros hallazgos.` });
      return;
    }
    imageCompressor(files[0])
      .then(compressed => fileToBase64(compressed))
      .then(base64 => setImages(prev => [...prev, base64]));
  };

  return (
    <Modal
      show={open}
      onHide={() => control(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Hallazgos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={formik.handleSubmit} id="form-finding">
          {!isIncidentReport && showCategory && (
            <div className="row">
              <div className="col-12 col-md-6 mb-3">
                <label className="form-label">Evaluación <span className="text-danger">*</span></label>
                <select
                  className={`form-select ${formik.touched.Evaluacion && formik.errors.Evaluacion ? "is-invalid" : ""}`}
                  name="Evaluacion"
                  value={formik.values.Evaluacion}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={isPreview}
                >
                  <option value="" hidden>Seleccione...</option>
                  {questions.map(q => (
                    <option key={q.id} value={q.id}>
                      {q.title}
                    </option>
                  ))}
                </select>
                {formik.touched.Evaluacion && formik.errors.Evaluacion && (
                  <div className="invalid-feedback">{formik.errors.Evaluacion}</div>
                )}
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label className="form-label">Categoría <span className="text-danger">*</span></label>
                <select
                  className={`form-select ${formik.touched.CategoriaId && formik.errors.CategoriaId ? "is-invalid" : ""}`}
                  name="CategoriaId"
                  value={formik.values.CategoriaId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={isPreview}
                >
                  <option value="" hidden>Seleccione...</option>
                  {findingCategories.map(cat => (
                    <option key={cat.id} value={cat.id}>
                      {cat.title}
                    </option>
                  ))}
                </select>
                {formik.touched.CategoriaId && formik.errors.CategoriaId && (
                  <div className="invalid-feedback">{formik.errors.CategoriaId}</div>
                )}
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-12 mb-3">
              <label className="form-label">Observación <span className="text-danger">*</span></label>
              <textarea
                rows="2"
                className={`form-control ${formik.touched.Observacion && formik.errors.Observacion ? "is-invalid" : ""}`}
                name="Observacion"
                value={formik.values.Observacion}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Escriba aquí."
                disabled={isPreview}
              />
              {formik.touched.Observacion && formik.errors.Observacion && (
                <div className="invalid-feedback">{formik.errors.Observacion}</div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <label className="form-label">Adjuntos</label>
            </div>
            {images.map((image, index) => (
              <div key={index} className="col-6 col-md-4">
                <div className="image-wrapper">
                  <img
                    src={image}
                    alt={"Image" + index}
                    className="img-thumbnail"
                    width="100%"
                    height="100%"
                  />
                  {!isPreview && (
                    <button
                      className="btn btn-danger delete-image"
                      type="button"
                      onClick={() => handleDeleteImage(index)}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                  )}
                </div>
              </div>
            ))}
            {!isPreview && (
              <div className="col-12 mt-4">
                <div className="d-flex flex-column">
                  {platform === "web" && (
                    <button
                      type="button"
                      className="btn bg-primary text-white fs-6 me-auto p-0"
                      disabled={images.length >= imagesLimit}
                    >
                      <label
                        htmlFor="form-upload"
                        className="w-100 h-100 py-1 px-3"
                      >
                        Cargar imagenes
                      </label>
                    </button>
                  )}
                  {platform !== "web" && (
                    <div className="d-flex">
                      <button
                        type="button"
                        className="btn bg-primary text-white fs-6 me-1"
                        onClick={() => takePhoto(CameraSource.Camera)}
                        disabled={images.length >= imagesLimit}
                      >
                        <FontAwesomeIcon icon={faCamera} className="me-2" />
                        Tomar foto
                      </button>
                      <button
                        type="button"
                        className="btn bg-primary text-white fs-6 me-auto"
                        onClick={() => takePhoto(CameraSource.Photos)}
                        disabled={images.length >= imagesLimit}
                      >
                        <FontAwesomeIcon icon={faImages} className="me-2" />
                        Galería
                      </button>
                    </div>
                  )}
                  {images.length >= imagesLimit && (
                    <small className="text-muted mt-1">
                      Máximo {imagesLimit} imágenes por hallazgo.
                    </small>
                  )}
                </div>
              </div>
            )}
          </div>
        </form>

        {platform === "web" && (
          <input
            id="form-upload"
            ref={uploadFile}
            name="images"
            onChange={event => webUpload(event.target.files)}
            type="file"
            capture="camera"
            accept="image/png,image/jpg,image/jpeg"
            hidden
          />
        )}
      </Modal.Body>
      {!isPreview && (
        <Modal.Footer>
          <button type="submit" form="form-finding" className="btn btn-success">
            Guardar hallazgo
          </button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default DialogFormFinding;
